import { ApplicationEvent } from './application-event.model';
import { ApplicationEventPriceFilterInteractionType, ApplicationEventType } from '../constants';

export class PlpPriceFilterInteractionEvent implements ApplicationEvent {

  type = ApplicationEventType.PLPPriceFilterInteraction;

  constructor(
    private interactionType: ApplicationEventPriceFilterInteractionType
  ){
  }

  getPayload(): any {
    return {
      type: this.interactionType
    };
  }
}
